
import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings, Info, LogOut } from "lucide-react";

interface SettingsCardsProps {
  onSignOut: () => Promise<void>;
}

const SettingsCards: React.FC<SettingsCardsProps> = ({ onSignOut }) => {
  return (
    <>
      {/* App Settings Card */}
      <Link to="/settings" className="block no-underline">
        <Card className="hover:bg-accent transition-colors">
          <CardContent className="p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center mr-3">
                <Settings className="h-5 w-5 text-gray-500" />
              </div>
              <div>
                <h3 className="font-medium">App Settings</h3>
                <p className="text-sm text-muted-foreground">Customize your experience</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>

      {/* Privacy & Legal Card */}
      <Link to="/legal" className="block no-underline">
        <Card className="hover:bg-accent transition-colors">
          <CardContent className="p-4">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center mr-3">
                <Info className="h-5 w-5 text-amber-500" />
              </div>
              <div>
                <h3 className="font-medium">Privacy & Legal</h3>
                <p className="text-sm text-muted-foreground">Terms and disclaimers</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </Link>

      {/* Sign Out Button */}
      <Button variant="outline" className="w-full" onClick={onSignOut}>
        <LogOut className="mr-2 h-4 w-4" />
        Sign Out
      </Button>
    </>
  );
};

export default SettingsCards;
